import {
    useFloating,
    useClick,
    useInteractions,
    useFocus,
    useDismiss,
    useRole,
    offset,
    flip,
    autoUpdate,
    shift,
    arrow,
    FloatingArrow,
} from '@floating-ui/react';
import classNames from 'classnames';
import React, { useState, useRef, ReactNode } from 'react';

import { Icon, IconTypes } from '@eika/icon';

import './Tooltip.scss';

const ARROW_HEIGHT = 7;
type TooltipProps = {
    title: string;
    dataTrackId?: string;
    children: ReactNode;
};
const Tooltip = ({ title, children, dataTrackId }: TooltipProps) => {
    const arrowRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const { refs, floatingStyles, context } = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        whileElementsMounted: autoUpdate,
        placement: 'bottom',
        middleware: [
            offset(5 + ARROW_HEIGHT),
            shift({ padding: 5 }),
            arrow({
                element: arrowRef,
            }),
            flip({
                crossAxis: false,
            }),
        ],
    });

    const click = useClick(context);
    const focus = useFocus(context, {
        enabled: true,
    });
    const dismiss = useDismiss(context);
    const role = useRole(context, { role: 'tooltip' });

    const { getReferenceProps, getFloatingProps } = useInteractions([click, focus, dismiss, role]);

    return (
        <>
            <>
                <button
                    className={classNames('sgw-tooltip__button', { 'sgw-tooltip__button--open': isOpen })}
                    ref={refs.setReference}
                    type="button"
                    data-track-id={dataTrackId ? `${dataTrackId}-tooltip` : ''}
                    data-track-linkname={dataTrackId ? title : ''}
                    {...getReferenceProps()}
                >
                    <Icon type={IconTypes.SPOERSMAAL_24} />
                </button>
                {isOpen && (
                    <div
                        className="sgw-tooltip__content-wrapper"
                        ref={refs.setFloating}
                        style={floatingStyles}
                        {...getFloatingProps()}
                    >
                        <FloatingArrow ref={arrowRef} context={context} height={ARROW_HEIGHT} width={16} />
                        <div className="sgw-tooltip__content typography-small">{children}</div>
                    </div>
                )}
            </>
        </>
    );
};

export default Tooltip;
